<template>
    <v-dialog v-model="show" @click:outside="$emit('update:show', false)" max-width="600">
        <v-card>
            <v-toolbar color="primary" dark flat>
                <v-toolbar-title class="text-capitalize">payment methods</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="subtitle-1 mt-3">
                <h4 class="mb-3">We have six (6) payment methods available at Kaoshi</h4>
                <p> <span class="font-weight-bold">ACH</span> - This payment method is also known as direct debit. The money is automatically taken from your bank account.</p>
                <p> <span class="font-weight-bold">P2P Bank Transfer</span> - This payment method requires you to login into your bank account to send money to an assigned bank account (zelle, interac, or bank account number). It is the safest option as it requires a manual login</p>
                <p> <span class="font-weight-bold">Debit Card</span> - This payment method involves you paying with your debit card</p>
                <p> <span class="font-weight-bold">Credit Card</span> - This payment method involves you paying with your credit card<p>
                <p> <span class="font-weight-bold">Wire Transfer</span> - This payment method requires you to login into your bank to make a payment to an assigned bank account via a wire transfer. You will get charged a wire transfer fee from your bank</p>
                <p> <span class="font-weight-bold">Cash Drop-Off</span> - This payment method requires you to drop off cash at the office of one of the international money transfer companies or its agents.</p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        show: Boolean,
    },
}
</script>

<style>

</style>